import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import l10n from "@/plugins/l10n";
import dayjs from "dayjs";
import { VueCookieNext } from "vue-cookie-next";
import { sync } from "vuex-router-sync";
import { getDeviceType } from "./utils/device";
import { getFormattedDate } from "./utils/date";
import { isInternalLink } from "./utils/links";
import { numberWithCurrency } from "./utils/numberCurrency";
import { logEvent } from "@/utils/analytics";
import customParseFormat from "dayjs/plugin/customParseFormat";
import * as Sentry from "@sentry/vue";
import { Integrations as TracingIntegrations } from "@sentry/tracing";

dayjs.extend(customParseFormat);

sync(store, router);

const app = createApp(App);

app.config.globalProperties.$redirect = (link, action = "replace") => {
  if (isInternalLink(link)) {
    router[action](link);
  } else {
    window.location = link;
  }
};
app.config.globalProperties.$isAndroid = getDeviceType() === "android";
app.config.globalProperties.$currencyFormatter = numberWithCurrency;
app.config.globalProperties.$settings = window.mybank_settings;
app.config.globalProperties.$getFormattedDate = getFormattedDate;
app.config.globalProperties.$logAnalyticEvent = logEvent;
app.config.globalProperties.$filter = {
  formatDate(dateString, formatString) {
    if (dateString) {
      return dayjs(String(dateString)).format(String(formatString));
    }
  },
};

Sentry.init({
  app: app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_MODE,
  release: process.env.VUE_APP_VERSION,
  debug: false,
  logErrors: false,
  sampleRate: process.env.NODE_ENV !== "production" ? 1.0 : 0.2,
  integrations: [
    new TracingIntegrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
  ],
  tracesSampleRate: process.env.NODE_ENV !== "production" ? 1.0 : 0.2,
});

Sentry.setUser({ id: VueCookieNext.getCookie("userId") })

app
  .use(l10n)
  .use(router)
  .use(store)
  .use(VueCookieNext)
  .mount("#app");

if (window) {
  window.mobapp_callbacks = {};
}
